import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import toast from 'react-hot-toast';
import { userAPI } from '../../services/api';
import PasswordField from './PasswordField';

// Permet à l'admin de définir un nouveau mot de passe pour un élève
// (utile si l'élève n'a plus accès à son email)
const AdminSetPasswordDialog = ({ open, onClose, student }) => {
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (saving) return;
    setPassword('');
    setError('');
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await userAPI.setPassword(student._id || student.id, password);
      toast.success(`Mot de passe de ${student.name} modifié`);
      setPassword('');
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Impossible de modifier le mot de passe');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Réinitialiser le mot de passe</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Choisissez un nouveau mot de passe pour <strong>{student?.name}</strong>, puis
            communiquez-le à l'élève. Il pourra le changer depuis son profil.
          </DialogContentText>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <PasswordField
            autoFocus
            required
            label="Nouveau mot de passe"
            autoComplete="new-password"
            inputProps={{ minLength: 6 }}
            helperText="Minimum 6 caractères"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={saving}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={saving}>
            Annuler
          </Button>
          <Button type="submit" variant="contained" disabled={saving || password.length < 6}>
            {saving ? <CircularProgress size={22} /> : 'Enregistrer'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AdminSetPasswordDialog;
